import { render } from "./WebLayout.vue?vue&type=template&id=2f9aa656&scoped=true&class=true"
import script from "./WebLayout.vue?vue&type=script&lang=js"
export * from "./WebLayout.vue?vue&type=script&lang=js"

import "./WebLayout.vue?vue&type=style&index=0&id=2f9aa656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9aa656"]])

export default __exports__